import { configureStore } from '@reduxjs/toolkit'
import persistedReducer from 'redux/reducers'
import { persistStore } from 'redux-persist'
import thunkMiddleware from 'redux-thunk'

const store = configureStore({
  reducer: persistedReducer,
  middleware: [thunkMiddleware],
})

const persistor = persistStore(store)

export { store, persistor }
